import { formatBotTimeStamp, generate6DigitUUID } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { appendTimeStamp } from 'js/conversation';
import { timeStamp } from './timeStamp.model';
import { TimeStampTemplate } from './timeStamp.template';

export class TimeStamp {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvent();
	}

	initData(propData = {}) {
		this.data = {
			...timeStamp,
			id: propData.id || generate6DigitUUID(),
			value: formatBotTimeStamp(propData.date),
		};
	}

	initWrapper() {
		const { firstStamp, id } = this.data;
		const mt = firstStamp ? '2px' : '8px';
		const wrapper = document.createElement('span');

		wrapper.id = `timestamp-${id}`;
		wrapper.classList.add('engt-timestamp');
		wrapper.setAttribute('data-messagetype', 'divider');
		wrapper.stye = `margin-top: ${mt}`;
		wrapper.innerHTML = TimeStampTemplate(this.data);
		this.html = wrapper;
	}

	initEvent() {
		if (window.ENGT_CHAT.timeStampTimer) {
			window.clearInterval(window.ENGT_CHAT.timeStampTimer);
		}

		window.ENGT_CHAT.timeStampTimer = setInterval(() => {
			const contentContainer = document.getElementById('engtChatContent');
			const chatContent = Array.from(contentContainer.children);
			const lastMsg = chatContent[chatContent.length - 1];
			if (ENGT_CHAT.get('config.isChatOpened') && !lastMsg.hasAttribute('data-messagetype')) {
				appendTimeStamp({});
			}
		}, 15 * 60 * 1000);

		window.addEventListener('beforeunload', (e) => {
			window.clearInterval(window.ENGT_CHAT.timeStampTimer);
		});
	}

	render() {
		return this.html;
	}
}
